import React from "react"

import { AppAsyncOfficesAutocomplete } from "@components"
import { errors, officesPickoff } from "@signals"


export default function OfficesPickoffAutocomplete({ ...props }) {

	return <AppAsyncOfficesAutocomplete
		value={officesPickoff.value}
		error={errors.value?.offices}
		onChange={e => officesPickoff.value = e.target.value}
		filters={{
			...props?.filters
		}}
		{...props}
	/>
}